import { useState, useEffect } from 'react';
import { useApi } from '../../../../../libs/data-access/src/api/useApi';
import { TPaginationStatus } from '../../../../../types';
import { PAGINATION_ITEM_LIMIT } from '../../../../../libs/data-access/constant';
import { handleUpdateStateOnResponse, showToast } from '../../../../../utils/utility';
import { IApplyFor } from '../../../../../libs/data-access/types';
export  const useApplyFor = () => {
    
    const {
        postData,
        patchData,
        putData
    } = useApi();

    const [isLoading, setIsLoading] = useState(false);
    const [isSwitchLoading, setIsSwitchLoading] = useState(false);
    const [isBtnLoading, setIsBtnLoading] = useState(false);
    const [isBtnLoadingIndex, setIsBtnLoadingIndex] = useState<number | undefined >(undefined);
    const [isOpenModalValue, setIsOpenModalValue] = useState<"New" | "Edit" | "Delete" | undefined >(undefined);
    const [searchValue, setSearchValue] = useState("");
    const [applyForList, setApplyForList] = useState<IApplyFor[]>([]);
    const [selectedApplyFor, setSelectedApplyFor] = useState<IApplyFor | undefined>(undefined);
    const [newApplyFor, setNewApplyFor] = useState<IApplyFor>({name:"" ,travelServiceCategory:"" ,formType:""});



    useEffect(() => {
        if(searchValue?.length > 2 || searchValue === ""){
        getApplyForList("INITIAL_PAGE");
    }
    }, [searchValue])


    // API FUNCTION
    const getApplyForList = async (paginationAction: TPaginationStatus, id?: number) => {
        setIsLoading(true);
        const response = await postData(`charge-apply-for-type/get-all`,
            {
                paginationFilterRequest: {
                    paginationAction: paginationAction,
                    maxLimit: PAGINATION_ITEM_LIMIT,
                    id: paginationAction === "INITIAL_PAGE" ? null : paginationAction === "NEXT_PAGE" ? applyForList[PAGINATION_ITEM_LIMIT-1]?.id : paginationAction === "PREVIOUS_PAGE" ? applyForList[0]?.id : null,
                    sortingOrder: "ASC"
                },
                search: searchValue ?? "",
            })
        setIsLoading(false);

        if (response.isSuccess) {
            setApplyForList(response.data.data)
        } else {
            setApplyForList([])
            showToast({
                type: "error",
                message: response.message ?? "Something went wrong",
            });
        };
    }


    const submitNewApplyFor = async () => {
        setIsBtnLoading(true);
        const response = await postData(`charge-apply-for-type/create`, newApplyFor);
        if (response.isSuccess) {
            showToast({
                type: "success",
                message: "Flight apply for added successfully",
            })
            setIsOpenModalValue(undefined);
            getApplyForList("INITIAL_PAGE");
        } else {
            showToast({
                type: "error",
                message: response.message ?? "Something went wrong",
            })
        };
        setIsBtnLoading(false);
    }

    const UpdateStatus = async (id: number, status: boolean , index: number) => {
        setIsBtnLoadingIndex(index);
        const response = await patchData(`charge-apply-for-type/${status ? "active-all" :  "inActive-all" }?ids=${[id]}`,{});
        if (response.isSuccess) {
            showToast({
                type: "success",
                message: "Flight apply for status updated successfully",
            })
            // getApplyForList("INITIAL_PAGE");
            setApplyForList(handleUpdateStateOnResponse(applyForList, id, response.data.data))

        } else {
            showToast({
                type: "error",
                message: response.message ?? "Something went wrong",
            })
        };
        setIsBtnLoadingIndex(undefined);
    }

    const UpdateFlightFor = async () => {
        setIsSwitchLoading(true);
        const response = await putData(`charge-apply-for-type/update`, selectedApplyFor);
        if (response.isSuccess) {
            showToast({
                type: "success",
                message: "Flight apply for type updated successfully",
            })
            // getApplyForList("INITIAL_PAGE");
            selectedApplyFor?.id &&setApplyForList(handleUpdateStateOnResponse(applyForList, selectedApplyFor?.id, response.data.data))
            setSelectedApplyFor(undefined);
            setIsOpenModalValue(undefined);
        } else {
            showToast({
                type: "error",
                message: response.message ?? "Something went wrong",
            })
        };
        setIsSwitchLoading(false);
    }

    const deleteFlightFor = async (id: number) => {
       const isConfirm = window.confirm("Are you sure you want to delete this?");
        if(!isConfirm) return;
        else{
            setIsBtnLoading(true);
            showToast({
                type:"success",
                title:"Ready to delete",
                message:"Add api to delete Flight For"
            })

        }
        // setIsBtnLoading(true);
        // const response = await putData(`charge-apply-for-type/delete`, {id: id});
        // if (response.isSuccess) {
        //     showToast({
        //         type: "success",
        //         message: "Flight apply for deleted successfully",
        //     })
        //     getApplyForList("INITIAL_PAGE");
        //     setSelectedApplyFor(undefined);
        // } else {
        //     showToast({
        //         type: "error",
        //         message: response.message ?? "Something went wrong",
        //     })
        // };
        // setIsBtnLoading(false);
    }

    return {
        isLoading,
        isSwitchLoading,
        isBtnLoadingIndex,
        isBtnLoading,
        isOpenModalValue,
        setIsOpenModalValue,
        applyForList,
        searchValue,
        setSearchValue,
        selectedApplyFor,
        setSelectedApplyFor,
        newApplyFor,
        setNewApplyFor,
        submitNewApplyFor,
        UpdateStatus,
        UpdateFlightFor,
        deleteFlightFor,
        getApplyForList
    }
}